import { Injectable } from "@angular/core";
import { GridDataResult } from "@progress/kendo-angular-grid";
import { BehaviorSubject } from 'rxjs';
import { HttpClient } from "@angular/common/http";
import { AppConstant } from "src/app/app.constant";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { DataResult, DataSourceRequestState } from "@progress/kendo-data-query";
import { LoaderService } from "src/app/_metronic/partials/content/loader/loader.service";

@Injectable()
export class ReportHistoryService {
    apiUrl: string;
    kendoDataUrl: string;
    constructor(private httpClient: HttpClient,
        private appConstant: AppConstant) {
        this.apiUrl = this.appConstant.getUrl()
    }

    public getAllReport(state): Observable<DataResult> {
        return this.httpClient.post(`${this.apiUrl}/getAllReport/`, state).pipe(
            map((response: any) => {
                return {
                    data: response.data,
                    total: response.total
                } as GridDataResult
            })
        ) as any as Observable<GridDataResult>
    }

}
